<template>
  <SimpleStackedChart
    :name="$t('Chart__NumberOfDiplomas__name')"
    :sheets="sheets"
  >
    <p class="fmhind-graph-number-of-diplomas__source">
      {{ $t('Chart__NumberOfDiplomas__source') }}
    </p>
  </SimpleStackedChart>
</template>

<script>
import data from '@/assets/json/NumberOfDiplomas.json';
import SimpleStackedChart from '@/components/ChartPartials/SimpleStackedChart';

export default {
  name: 'NumberOfDiplomas',
  components: {
    SimpleStackedChart
  },
  data() {
    return {
      sheets: data
    };
  }
};
</script>

<style lang="scss">
.fmhind-graph-number-of-diplomas__source {
  @extend %chart-source;
}
</style>
